import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/presentation/contexts/AuthContext';
import { AccessDenied } from './AccessDenied';

interface ProtectedRouteProps {
  children: React.ReactNode;
  require?: 'administer' | 'manageUsers';
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, require }) => {
  const { isAuthenticated, isLoading, canAdminister, canManageUsers } = useAuth();

  const hasStoredToken = !!localStorage.getItem('admin_token');
  const hasStoredUser = !!localStorage.getItem('admin_user');
  const hasStoredAuth = hasStoredToken && hasStoredUser;

  if (isLoading && !hasStoredAuth) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-gray-600 dark:text-gray-400">Loading...</div>
      </div>
    );
  }

  const isReallyAuthenticated = hasStoredAuth || (isAuthenticated && !isLoading);

  if (!isReallyAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (require === 'administer' && !canAdminister) {
    return <AccessDenied />;
  }
  if (require === 'manageUsers' && !canManageUsers) {
    return <AccessDenied />;
  }

  return <>{children}</>;
};
